<template>
  <v-container fluid class="custom-container">

    <!-- Status Cards -->
    <folder-status-cards 
      v-if="folders && folders.length > 0"
      :folders="folders" 
      :counts="unreceivedCounts" 
      context="unreceived"
    />

    <!-- Folders Header -->

    <v-layout
      v-if="!isEmpty(groupedFolders)"
      class="mb-2 list-folders-actions align-center"
      row
      wrap
    >
      <v-flex xs12 sm6 md3>
        <div class="d-flex align-center">
          <strong v-if="!isEmpty(activeFolderFilterType)" class="mr-2">Filtrado por:</strong>
          <v-chip
            v-if="!isEmpty(activeFolderFilterType)"
            close
            @input="resetFolders"
            color="white"
          >{{ activeFolderFilterType.name }}
          </v-chip>
        </div>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <div class="d-flex align-center">
          <span class="mr-2">Exibindo {{ pageStart }} - {{ pageStop }} de {{ foldersCount }}</span>
          <v-btn icon small @click="pageNumber--" :disabled="pageNumber <= 1">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-btn icon small @click="pageNumber++" :disabled="pageNumber >= pages">
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-select
          v-model="orderFilter"
          :items="orderFilters"
          item-text="name"
          return-object
          hide-details
          solo
          flat
          dense
        />
      </v-flex>
      <v-flex xs12 sm6 md3 class="justify-center" style="display: flex">
        <v-btn-toggle v-model="viewMode" mandatory dense>
          <v-btn flat small :value="'list'">
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-btn>
          <!-- <v-btn flat small :value="'grid'">
            <v-icon>mdi-grid</v-icon>
          </v-btn>-->
        </v-btn-toggle>
      </v-flex>
    </v-layout>

    <!-- Vista em Lista -->
    <template v-if="viewMode === 'list'">
      <section class="folders">
        <v-layout
          class="folder-list mt-4"
          v-for="(group,index) in groupedFolders"
          :key="index"
          column
        >
          <span
            class="subheading grey--text my-2 text-capitalize"
          > {{ index }}</span>

          <div class="elevation-1 group" v-if="group.length > 0">
            <draggable :options="{ delay: dragDelay }">
              <transition-group
                name="fade-cascade"
                tag="div"
                class="cascade-group"
                appear
              >
                <folder-card
                  v-for="(folder, folderIndex) in group"
                  :key="`${folder.id}-${folderIndex}`"
                  :folder="folder"
                  :draggingItemId="draggingItemId"
                  :style="{ '--cascade-delay': `${folderIndex * 0.05}s` }"
                  @update:draggingItemId="id => draggingItemId = id"
                  @drag-start="startDrag"
                  @open-folder="openFolder"
                />
              </transition-group>
            </draggable>
          </div>
        </v-layout>
      </section>
    </template>

    <!-- Vista em Grid -->
    <template v-else>
      <section class="folders">
        <v-layout
          class="folder-list mt-4"
          v-for="(group,index) in groupedFolders"
          :key="index"
          column
        >
          <span
            class="subheading grey--text my-2 text-capitalize"
          > {{ index }}</span>

          <folder-grid
            :folders="group"
            v-if="group.length > 0"
          />
        </v-layout>
      </section>
    </template>

    <!-- Empty Content -->
    <v-container fill-height v-if="isEmpty(groupedFolders) && !loading.show">
      <v-layout column align-center justify-center>
        <v-icon class="mb-2" size="48" color="grey darken-2">mdi-file-cancel</v-icon>
        <span class="title font-weight-regular grey--text text--darken-2">
            Não há itens para exibir
          </span>
      </v-layout>
    </v-container>

  </v-container>
</template>


<script>
import { isEmpty, truncate } from "lodash";
import acronym from "@/utils/acronym";
import shortName from "@/utils/short-name";
import format from "date-fns/format";
import * as ptLocale from "date-fns/locale/pt";
import bus from "@/utils/event-bus";
import CurrentOwner from "@/components/inbox/CurrentOwner";
import TermComponent from "@/components/inbox/TermComponent";
import foldersService from "../../../../services/FoldersService";
import draggable from "vuedraggable";
import getColorByText from '@/assets/utils/colorByText';
import FolderStatusCards from '@/components/folder/FolderStatusCards';

export default {
  name: "inbox",
  components: {
    CurrentOwner,
    TermComponent,
    draggable,
    FolderCard: () => import('@/components/folder/FolderCard'),
    FolderGrid: () => import('@/components/folder/FolderGrid'),
    FolderStatusCards
  },
  props: { messages: Array },
  mounted() {
    // this.setInboxFoldersTypes();
    bus.$on("folderCreated", () => {
      this.getFolders();
    });
    bus.$on("loadInboxFolder", () => {
      this.getFolders();
    });
  },
  data() {
    return {
      firstRender: true,
      orderFilters: [
        // { name: "Menor prazo", property: "limit_date", order: "asc" },
        // { name: "Maior prazo", property: "limit_date", order: "desc" },
        {
          name: "Tramitação mais antiga",
          property: "effective_updated_at",
          order: "asc"
        },
        {
          name: "Tramitação mais recente",
          property: "effective_updated_at",
          order: "desc"
        },
        // {
        //   name: "Por Setor",
        //   property: "administrative_unit",
        //   order: "asc"
        // }
      ],
      orderFilter: {
        name: "Tramitação mais recente",
        property: "effective_updated_at",
        order: "desc"
      },
      truncateText: truncate,
      shortName,
      isEmpty,
      pageNumber: 1,
      rowsPerPage: 20,
      draggingItemId: null,
      timer: null,
      dragDelay: 1500,
      viewMode: 'list',  // 'list' ou 'grid'
      isLoadingFolders: false  // Flag para controlar requisições simultâneas
    };
  },
  methods: {
    startTimer(id) {
      this.timer = setTimeout(() => {
        this.setDraggingItem(id);
      }, this.dragDelay);
    },
    stopTimer() {
      clearTimeout(this.timer);
      this.setDraggingItem(null);
    },
    setDraggingItem(id) {
      this.draggingItemId = id;
    },
    startDrag(id) {
      this.$store.commit("setDraggingFolder", id);
    },
    folderNotReceivedClass(folder) {
      if (folder.current_owner.id === this.user.id) {
        return "received-folder";
      }
      return "";
    },
    folderIcon(folder) {
      if (folder.current_owner.id === this.user.id) {
        return "/static/images/folder/folder-open-icon.svg";
      }
      return "/static/images/folder/folder-closed-icon.svg";
    },
    acronym(string) {
      return acronym(string);
    },
    currentUserIsOwner(currentOwner) {
      return this.user.id === currentOwner.id;
    },
    getFolders(loading = true) {
      // Evita requisições simultâneas
      if (this.isLoadingFolders) {
        console.log('Requisição já em andamento. Ignorando nova requisição de getFolders.')
        return;
      }

      this.isLoadingFolders = true;

      if (loading) {
        this.$store.dispatch("toggleLoader", { show: true });
      }

      this.$store
        .dispatch("getFoldersUnreceived", {
          page: this.pageNumber,
          limit: this.rowsPerPage,
          order: this.orderFilter.order,
          sort: this.orderFilter.property,
          searchText: this.searchText || "",
          folderTypeId: this.folderTypeSelected.id || "",
          administrativeUnitId: this.selectedAdministrativeUnit || ""
        })
        .finally(() => {
          this.$store.dispatch("toggleLoader", { show: false });
          this.$store.dispatch("setLoadingSearchText", false);
          this.isLoadingFolders = false;
        });
    },
    openFolder(id) {
      const route = this.$router.resolve(`/pastas/${id}/show`);
      window.open(route.href, "_blank");
    },
    formatDate(date) {
      return format(date, "DD/MM/YYYY");
    },
    formatMonthYear(date) {
      return format(date, "MMMM [de] YYYY", { locale: ptLocale });
    },
    resetFolders() {
      this.pageNumber = 1;
      this.$store.dispatch("setFolderTypeSelected", "");
      // this.$store.dispatch('getFoldersInbox');
      this.$store.dispatch("setActiveFolderFilterType", {});
    },
    setInboxFoldersTypes() {
      // foldersService.getFolderTypesOnInbox().then(response => {
      //   this.$store.dispatch("setFolderTypes", response.data);
      // });
    },
    orderDateToString(folder) {
      switch (this.orderFilter.property) {
        case "limit_date":
          return folder.limit_date == null
            ? "Sem limite"
            : this.formatMonthYear(folder.limit_date);
        case "updated_at":
          // Usar o sort_updated_at que vem do backend
          const date = folder.sort_updated_at || folder.updated_at;
          return this.formatMonthYear(date);
        case "created_at":
          if (folder.last_transaction == null) {
            return "Processos não tramitados";
          }
          return this.formatMonthYear(folder.last_transaction.created_at);
        case "administrative_unit":
          if (folder.current_owner && folder.current_owner.administrative_unit) {
            return folder.current_owner.administrative_unit.abbreviation;
          }
          return "Sem setor";
        default:
          return "Sem agrupamento";
      }
    },
    getAdminUnitColor(unit) {
      if (!unit) return '#000000';
      return getColorByText(unit.abbreviation || unit.name);
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    selectedAdministrativeUnit() {
      return this.$store.getters.selectedAdministrativeUnit;
    },
    loading() {
      return this.$store.getters.loading;
    },
    activeFolderFilterType() {
      return this.$store.getters.activeFolderFilterType;
    },
    folders() {
      return this.$store.getters.folders;
    },
    received() {
      if (this.$store.getters.folders.length === undefined) {
        return [];
      }

      let received = this.$store.getters.folders.filter(
        item => item.folder_section === "inbox"
      );

      // Adicionar received_status às pastas se necessário
      received = received.map(item => {
        // Para a pasta "unreceived", geralmente o status é "Não Recebido"
        if (!item.received_status) {
          return {
            ...item,
            received_status: item.last_transaction && item.last_transaction.received_status
              ? item.last_transaction.received_status
              : 'Não Recebido'
          };
        }
        return item;
      });

      // if (!isEmpty(this.activeFolderFilterType)) {
      //   received = this.$store.getters.folders.filter(
      //     item => item.folder_section === 'inbox',
      //   );
      //   received = received.filter(
      //     item => item.folder_type.id === this.activeFolderFilterType.id,
      //   );
      //   this.$store.dispatch('setFoldersFound', received);
      // }
      return received;
    },
    groupedFolders() {
      const group = {};
      const orderedKeys = [];

      this.received.forEach(folder => {
        const date = folder.last_transaction && folder.last_transaction.updated_at
          ? new Date(folder.last_transaction.updated_at)
          : (folder.updated_at ? new Date(folder.updated_at) : null);
        const key = date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}` : 'Sem data';
        if (!group[key]) {
          group[key] = { folders: [folder], date: date };
          orderedKeys.push(key);
        } else {
          group[key].folders.push(folder);
        }
      });

      orderedKeys.sort((a, b) => {
        if (group[a].date && group[b].date) {
          return this.orderFilter.order === 'asc'
            ? group[a].date - group[b].date
            : group[b].date - group[a].date;
        }
        return 0;
      });

      const orderedGroups = {};
      orderedKeys.forEach(key => {
        const label = group[key].date
          ? this.formatMonthYear(group[key].date)
          : 'Sem data';
        orderedGroups[label] = group[key].folders;
      });

      return orderedGroups;
    },
    pages() {
      return this.$store.getters.foldersPagesCount;
    },
    foldersCount() {
      return this.$store.getters.activeTotalFolders;
    },
    pageStart() {
      return this.pageNumber * this.rowsPerPage - (this.rowsPerPage - 1);
    },
    pageStop() {
      return Math.min(
        this.pageStart + (this.rowsPerPage - 1),
        this.foldersCount
      );
    },
    searchText() {
      return this.$store.getters.searchText;
    },
    folderTypeSelected() {
      return this.$store.getters.folderTypeSelected;
    },
    unreceivedCounts() {
      return this.$store.getters.unreceivedCounts;
    }
  },
  watch: {
    pageNumber: { handler: "getFolders", immediate: true },
    searchText(val) {
      if (val === null || val === "" || val.length > 2) {
        this.getFolders(false);
      }
    },
    folderTypeSelected() {
      this.getFolders();
    },
    orderFilter: { handler: "getFolders" },
    // Observa mudanças na unidade administrativa selecionada
    selectedAdministrativeUnit: {
      handler() {
        // Reseta para página 1 e não dispara getFolders aqui,
        // pois o watcher do pageNumber já vai cuidar disso
        this.pageNumber = 1;
      }
    },
    // Impede recarga quando o número de pastas muda por outros motivos
    foldersCount: {
      handler() {
        // Não recarrega aqui, evitando requisições duplicadas
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/folder-list-margins.scss';

.received-folder {
  background: #f2f2f2;
  font-weight: 600 !important;

  &.caption {
    font-weight: 600 !important;
  }
}

// Override específico para unreceived com position absolute
.list-folders-actions {
  position: absolute;
  z-index: 4;
  width: 97%;
}

.dragging {
  background-color: #005ece;
}

.fade-cascade-enter-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 1;
  transform: translateY(0);
}
.fade-cascade-enter {
  opacity: 0;
  transform: translateY(20px);
}
.fade-cascade-enter-to {
  opacity: 1;
  transform: translateY(0);
}
.cascade-group > * {
  transition-delay: var(--cascade-delay, 0s);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/folder/list/unreceived/Unreceived.vue